import { articleStatus } from 'modules/knowledgebase/model'

export const formatStatusText = text => {
  if (!text) return;
  
  const lowerCaseText = text === articleStatus.PUBLISHED ? 'public' : text.toLowerCase()
  return lowerCaseText.charAt(0).toUpperCase() + lowerCaseText.slice(1);
}